import React, { useEffect } from 'react'
import { Alert, Segmented, Space, Typography } from 'antd'
import { usePaymentMethod } from '../hooks'

import styles from './PricingToggle.module.css'
import { useSubscriptionStatus } from 'hooks'

const { Text } = Typography

export const PricingToggle: React.FC = () => {
  const { billingPeriod, setBillingPeriod } = usePaymentMethod()
  const { status: subscriptionStatus } = useSubscriptionStatus()

  useEffect(() => {
    // If only one billing period is available, set it automatically
    if (subscriptionStatus.monthly && !subscriptionStatus.yearly) {
      setBillingPeriod('yearly')
    }
    if (!subscriptionStatus.monthly && subscriptionStatus.yearly) {
      setBillingPeriod('monthly')
    }
  }, [subscriptionStatus, setBillingPeriod])

  if (subscriptionStatus.monthly || subscriptionStatus.yearly) {
    return null
  }

  return (
    <div className={styles.container}>
      <Space direction="vertical" size="small" align="center">
        <Segmented
          options={[
            { label: 'Yearly', value: 'yearly' },
            { label: 'Monthly', value: 'monthly' },
          ]}
          value={billingPeriod}
          style={{
            borderRadius: 8
          }}
          disabled={subscriptionStatus.monthly || subscriptionStatus.yearly ? true : false}
          className={styles.segmented}
          onChange={(val) => setBillingPeriod(val as 'monthly' | 'yearly')}
          block
        />
        {billingPeriod === 'monthly' && (
          <Alert type="info"
            message="Switch to yearly subscription and get one month for free"
          />
        )}
        {billingPeriod === 'yearly' && (
          <Alert type="info"
            message="Great choice! Enjoy the one month free discount 😍"
          />
        )}
      </Space>
    </div>
  )
}
